/* eslint-disable import/extensions */
import lscache from 'lscache';
import { date, extract, http, layout, store, } from '@/helpers/index';
import { constant } from '@/helpers/constant';

export const auth = {
  apiKey: '2a1be880-4451-4b7d-968c-af8f6b793fd3',
  headers: () => ({ 'x-api-key': auth.apiKey }),
  store: {
    set: (key, value) => {
      if (value) {
        lscache.set(key, value);
      }
      return value;
    },
    get: (key) => lscache.get(key),
    remove: (key) => lscache.remove(key),
    logged: {
      set: (value, expire) => {
        if (value) {
          lscache.set('logged', value, expire || 60 * 8);
        }
        return value;
      },
      get: () => lscache.get('logged'),
      remove: () => lscache.remove('logged'),
    },
    token: {
      set: (value, expire) => {
        if (value) {
          lscache.set('token', value, expire || 60 * 8);
        }
        return value;
      },
      get: () => lscache.get('token'),
      remove: () => lscache.remove('token'),
    },
  },
  logout: async (callback) => {
    layout.loading(true);
    http.delete('/security/auth/invalidate', null, (_data) => {
      layout.loading(false);
      store.menu.crm.remove();
      store.filter.remove('-profile-histories');
      store.filter.remove('-profile-orders');
      store.filter.remove('-profile-communications');
      store.filter.remove('-profile-diagnoses');
      auth.store.logged.remove();
      auth.store.token.remove();
      if (auth.store.get('token-admin')) {
        const token = auth.store.get('token-admin');
        const payload = extract.jwt.payload(token);
        let expire = null;
        if (payload) {
          expire = date.diff.minutes(new Date(), new Date(payload.exp * 1000));
        }
        auth.store.logged.set(auth.store.get('logged-admin'), expire);
        auth.store.token.set(token, expire);
        auth.store.remove('logged-admin');
        auth.store.remove('token-admin');
        store.remove('my-area-tab');
        window.location.href = '/crm/mix';
        return;
      }
      if (callback) {
        callback();
      }
    });
  },
  logged: async (callback, redirect) => {
    const pages = ['/sign-in', constant.redirect.login, '/sign-up', constant.redirect.register];
    if (!auth.store.token.get()) {
      if (redirect && pages.indexOf(layout.route.get()) === -1) {
        window.location.href = constant.redirect.login;
      }
      return;
    }
    callback(auth.store.logged.get());
  },
  check: (user, callback) => {
    if (!user) {
      callback();
      return;
    }
    auth.logged((logged) => {
      if (!logged?._id || user._id !== logged._id) {
        callback();
        return;
      }
      if (layout.route.get().indexOf('/crm') !== -1) {
        http.get('/manager/notifications/updates', (data) => {
          store.notifications.updates.set(data);
          callback(logged);
        });
        return;
      }
      callback(logged);
    }, true);
  },
  impersonate: async (username) => {
    layout.loading(true);
    http.post('/security/impersonate', {
      username,
    }, (result) => {
      if (result) {
        auth.store.set('logged-admin', auth.store.logged.get());
        auth.store.set('token-admin', auth.store.token.get());
        auth.store.logged.set(result.data.user);
        auth.store.token.set(result.data.token);
        store.remove('my-area-tab');
        window.location.href = constant.redirect.customer;
        return;
      }
      layout.loading(false);
    });
  },
};
